import type { IconData } from '@stacksjs/iconify-core'

export const autoFlash: IconData = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\" d=\"M12.029 25.19a62 62 0 0 1-7.47-1.543c-1.852-.512-2.496-2.64-1.341-4.177C6.004 15.762 11.1 9.234 16.666 3.34c1.54-1.628 4.14-.45 3.97 1.785c-.352 4.576-.798 8.078-1.107 11.161a47 47 0 0 1 8.203 1.943c1.749.589 2.296 2.64 1.19 4.116c-2.755 3.672-7.929 10.322-13.59 16.315c-1.538 1.63-4.167.45-4.062-1.789c.225-4.776.448-8.575.759-11.68ZM28 45l2.133-6m0 0l3.761-10.577C34.196 27.573 35.044 27 36 27s1.804.573 2.106 1.423L41.866 39m-11.733 0h11.734m0 0L44 45\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default autoFlash
